import * as THREE from 'three';

/**
 * World units that map to one screen pixel at `point`. Required reading:
 * CLAUDE.md "Screen-space sized handles & markers". Camera-distance is wrong
 * for ortho (1000m dolly → ~10× too big). Derive from the visible viewport.
 *
 * Shared by every screen-space-sized picking-tool marker (MeasuringTool,
 * SavedMeasurements, CrestGuideTool, …) — extracted here rather than
 * duplicated per-file. The body must stay byte-identical to what it was
 * before extraction; this is load-bearing maths, not a place to "improve"
 * incidentally.
 */
export const getUnitsPerPixel = (camera: THREE.Camera, renderer: THREE.WebGLRenderer, point: THREE.Vector3) => {
  const pr = renderer.getPixelRatio();
  const height = renderer.domElement.clientHeight * pr;
  if (camera.type === 'OrthographicCamera') {
    const o = camera as THREE.OrthographicCamera;
    const worldScreenHeight = Math.abs(o.top - o.bottom) / Math.max(o.zoom, 1e-6);
    return worldScreenHeight / Math.max(height, 1);
  }
  const p = camera as THREE.PerspectiveCamera;
  const d = camera.position.distanceTo(point);
  const vFOV = (p.getEffectiveFOV() * Math.PI) / 180;
  const worldScreenHeight = 2 * d * Math.tan(vFOV / 2);
  return worldScreenHeight / Math.max(height, 1);
};
